import { render, staticRenderFns } from "./SalaryRemarkDialog.vue?vue&type=template&id=c71d6d28&scoped=true"
import script from "./SalaryRemarkDialog.vue?vue&type=script&lang=js"
export * from "./SalaryRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./SalaryRemarkDialog.vue?vue&type=style&index=0&id=c71d6d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d6d28",
  null
  
)

export default component.exports